import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border border-white/20 px-4 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-white/60 transition-colors text-sm";

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-12">
          <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-4">Admin Access</p>
          <h1 className="font-serif-display text-4xl font-light tracking-[0.1em] uppercase">IGNOTA PARS</h1>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input
            data-testid="admin-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={field}
            required
          />
          <input
            data-testid="admin-password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={field}
            required
          />
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-white text-black py-4 font-mono-label text-xs uppercase tracking-luxe hover-invert hover:bg-transparent hover:text-white border border-white disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
